import { useMemo } from "react";
import { Autocomplete, Box, Button, TextField } from "@mui/material";
import { Countries } from "../../../utils/Lookup";
import { GroupHeader, GroupItems } from "../../../utils/Styled";

export default function LinkMillionProduct({ products, value, onChange, onSave, onCancel, loading = false }) {
    const sortedProducts = useMemo(() => {
        return [...products].sort((a, b) => {
            if (a.country_id === b.country_id) {
                return (a.product_description || "").localeCompare(b.product_description || "");
            }
            return (a.country_id || 0) - (b.country_id || 0);
        });
    }, [products]);

    return (
        <Box sx={{ minWidth: 380, display: "flex", gap: 1, alignItems: "center" }}>
            <Autocomplete
                size="small"
                options={sortedProducts}
                value={value}
                onChange={(event, selectedOption) => onChange(selectedOption)}
                isOptionEqualToValue={(option, selectedValue) => option.product_id === selectedValue?.product_id}
                groupBy={(option) => {
                    const country = Countries.find((item) => item.id === option.country_id);
                    return country ? country.name : "Unknown";
                }}
                getOptionLabel={(option) => option?.product_description || ""}
                renderOption={(props, option) => (
                    <li {...props} key={option.product_id}>
                        {option.product_description}
                    </li>
                )}
                renderGroup={(params) => {
                    return (
                        <li key={params.key}>
                            <GroupHeader>{params.group}</GroupHeader>
                            <GroupItems>{params.children}</GroupItems>
                        </li>
                    );
                }}
                renderInput={(params) => <TextField {...params} label="Select CRM Product" placeholder="Search product" />}
                fullWidth
            />
            <Button variant="contained" color="primary" onClick={onSave} disabled={!value || loading} sx={{ color: "#fff" }}>
                Save
            </Button>
            <Button variant="contained" color="error" onClick={onCancel} disabled={loading} sx={{ color: "#fff" }}>
                Cancel
            </Button>
        </Box>
    );
}
